import type { DefaultOptionType } from 'antd/lib/select';

export const PROGRAMS_OPTIONS: DefaultOptionType[] = [
  {
    label: '創意芳香手工皂',
    value: '創意芳香手工皂',
  },
  {
    label: '陶藝手拉胚(入門)',
    value: '陶藝手拉胚(入門)',
  },
];
